export default "https://cdn.questicon.mathletics.com/assets/audio/correct1Star-9d1417c1584aece0d5dfcd9649d14372.mp3";